import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { openHeritagePlaque } from './index';

const PLAQUE_POINTS = [
  { ath: 31.234, atv: -5.599 },
  { ath: 51.709, atv: -4.673 },
  { ath: 50.936, atv: 10.687 },
  { ath: 43.307, atv: 11.226 },
  { ath: 43.134, atv: 30.519 },
  { ath: 46.756, atv: 30.413 },
  { ath: 44.909, atv: 35.672 },
  { ath: 41.26, atv: 36.44 },
  { ath: 35.056, atv: 34.332 },
  { ath: 35.28, atv: 31.616 },
  { ath: 39.18, atv: 29.131 },
  { ath: 39.48, atv: 10.919 },
  { ath: 28.37, atv: 12.055 },
];

const Layer = styled.svg`
  position: absolute;
  inset: 0;
  z-index: 16;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
`;

const Hit = styled.polygon`
  fill: rgba(0, 0, 0, 0.01);
  stroke: none;
  cursor: pointer;
  pointer-events: fill;
`;

type KrpanoSphere = {
  spheretoscreen?: (ath: number, atv: number) => { x?: number; y?: number };
};

const PlaqueHitOverlay = () => {
  const [points, setPoints] = useState('');

  useEffect(() => {
    let alive = true;
    const draw = () => {
      if (!alive) return;
      const krpano = (window as unknown as { krpanoViewSnapshot?: KrpanoSphere })
        .krpanoViewSnapshot;
      if (typeof krpano?.spheretoscreen === 'function') {
        const mapped = PLAQUE_POINTS.map(point => {
          const screen = krpano.spheretoscreen?.(point.ath, point.atv);
          const x = Number(screen?.x);
          const y = Number(screen?.y);
          if (!Number.isFinite(x) || !Number.isFinite(y)) return '';
          return `${x},${y}`;
        }).filter(Boolean);
        const next = mapped.length > 2 ? mapped.join(' ') : '';
        setPoints(current => (current === next ? current : next));
      }
      window.requestAnimationFrame(draw);
    };
    const frame = window.requestAnimationFrame(draw);
    return () => {
      alive = false;
      window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <Layer data-hit="plaque" aria-hidden="true">
      {points ? (
        <Hit
          points={points}
          onClick={event => {
            event.stopPropagation();
            openHeritagePlaque();
          }}
        />
      ) : null}
    </Layer>
  );
};

export default PlaqueHitOverlay;
